module.exports = __webpack_public_path__ + "static/media/flute.5212ba25.ogg";